import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";

export default function AdminLogin() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      nav("/admin");
    } catch (err) {
      const msg = err?.response?.data?.detail || "Invalid credentials";
      toast.error(typeof msg === "string" ? msg : "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen grid place-items-center bg-[var(--pz-ink)] text-white px-4 relative overflow-hidden">
      <div className="absolute inset-0 grid place-items-center pointer-events-none">
        <div className="pz-watermark text-[22vw] leading-[0.8]">admin</div>
      </div>
      <form onSubmit={onSubmit} className="relative w-full max-w-md admin-panel rounded-md p-8">
        <Link to="/" className="flex items-center gap-3 mb-8">
          <span className="relative h-10 w-10 grid place-items-center">
            <span className="absolute inset-0 bg-[var(--pz-red)] rotate-45 rounded-md" />
            <span className="relative font-display text-white text-lg leading-none">A</span>
          </span>
          <div className="leading-none">
            <div className="font-display text-white font-bold uppercase tracking-wide">Admin</div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-zinc-500 mt-1">Control Room</div>
          </div>
        </Link>
        <h1 className="font-display text-3xl font-bold uppercase">Sign in</h1>
        <p className="text-zinc-400 text-sm mt-2">Manage banners, events, products, blogs and more.</p>

        <div className="mt-6 space-y-4">
          <div>
            <label className="block text-[10px] uppercase tracking-[0.2em] font-bold text-zinc-400 mb-2">Email</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-login-email" className="admin-input" />
          </div>
          <div>
            <label className="block text-[10px] uppercase tracking-[0.2em] font-bold text-zinc-400 mb-2">Password</label>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-login-password" className="admin-input" />
          </div>
          <button data-testid="admin-login-submit" disabled={loading} className="btn-red w-full justify-center disabled:opacity-60">{loading ? "Signing in..." : "Sign in"}</button>
        </div>
      </form>
    </div>
  );
}
